export const GET_CHARTS = 'GET_CHARTS';
export const GET_CHARTS_SUCCESS = 'GET_CHARTS_SUCCESS';
export const GET_CHARTS_FAILURE = 'GET_CHARTS_FAILURE';
export const INVITE_MEMBERS = 'INVITE_MEMBERS';
export const SHARE_CHART = 'SHARE_CHART';
export const EXPORT_CHART = 'EXPORT_CHART';
